export const oldRouters = [
  {
    state: 'app.dashboards_machines_machines',
    url: '/dashboards/machines',
    isDetail: false,
  },
  {
    state: 'app.dashboards_machines_machine',
    url: '/dashboards/machines',
    isDetail: true,
  },
  {
    state: 'app.report_explorer_downtime',
    url: '/production-explorer/downtime',
    isDetail: false,
  },
  {
    state: 'app.report_explorer_good-production',
    url: '/production-explorer/good-production',
    isDetail: false,
  },
  {
    state: 'app.explorer_oee',
    url: '/production-explorer/oee',
    isDetail: false,
  },
  {
    state: 'app.report_explorer_goodparts_pathfinder',
    url: '/production-explorer/pathfinder-goodparts',
    isDetail: false,
  },
  {
    state: 'app.report_explorer_operations_pathfinder',
    url: '/production-explorer/pathfinder-operations',
    isDetail: false,
  },
  {
    state: 'app.report_explorer_scrap',
    url: '/production-explorer/scrap',
    isDetail: false,
  },
  {
    state: 'app.explorer_target-oee',
    url: '/production-explorer/target-oee',
    isDetail: false,
  },
  {
    state: 'app.inventory.coils',
    url: '/inventory/coils',
    isDetail: false,
  },
  {
    state: 'app.inventory.coils.coil',
    url: '/inventory/coils',
    isDetail: true,
  },
  {
    state: 'app.inventory.coil-types',
    url: '/inventory/coil-types',
    isDetail: false,
  },
  {
    state: 'app.inventory.coil-types.coil-type',
    url: '/inventory/coil-types',
    isDetail: true,
  },
  {
    state: 'app.machines_pathfinder',
    url: '/machines/pathfinder',
    isDetail: false,
  },
  {
    state: 'app.machines_xl200',
    url: '/machines/xl200',
    isDetail: false,
  },
  {
    state: 'app.machines_xl200_detail',
    url: '/machines/xl200',
    isDetail: true,
  },
  {
    state: 'app.orders.list',
    url: '/orders',
    isDetail: false,
  },
  {
    state: 'app.orders.detail',
    url: '/orders',
    isDetail: true,
  },
  {
    state: 'app.punch-patterns_list',
    url: '/punching/patterns',
    isDetail: false,
  },
  {
    state: 'app.punch-patterns_list.detail',
    url: '/punching/patterns',
    isDetail: true,
  },
  {
    state: 'app.report_coil-scrap',
    url: '/report/coil-scrap',
    isDetail: false,
  },
  {
    state: 'app.report_coil-summary',
    url: '/report/coil-summary',
    isDetail: false,
  },
  {
    state: 'app.report_downtime-summary',
    url: '/report/downtime-summary',
    isDetail: false,
  },
  {
    state: 'app.report_material-demand',
    url: '/report/material-demand',
    isDetail: false,
  },
  {
    state: 'app.report_material-usage',
    url: '/report/material-usage',
    isDetail: false,
  },
  {
    state: 'app.report_order-sequence',
    url: '/report/order-sequence',
    isDetail: false,
  },
  {
    state: 'app.report_order-summary',
    url: '/report/order-summary',
    isDetail: false,
  },
  {
    state: 'app.report_production-events',
    url: '/report/production-events',
    isDetail: false,
  },
  {
    state: 'app.report.production-summary',
    url: '/report/production-summary',
    isDetail: false,
  },
  {
    state: 'app.report_quality-audit',
    url: '/report/quality-audit',
    isDetail: false,
  },
  {
    state: 'app.report_scrap-summary',
    url: '/report/scrap-summary',
    isDetail: false,
  },
  {
    state: 'app.report_tool-usage',
    url: '/report/tool-usage',
    isDetail: false,
  },
  {
    state: 'app.report_tooling-usage',
    url: '/report/tooling-usage',
    isDetail: false,
  },
  {
    state: 'app.schedule_jobs',
    url: '/schedule/jobs',
    isDetail: false,
  },
  {
    state: 'app.schedule_downtime',
    url: '/schedule/downtime',
    isDetail: false,
  },
  {
    state: 'app.schedule_timeline',
    url: '/schedule/timeline',
    isDetail: false,
  },
  {
    state: 'app.agent-settings',
    url: '/settings/agent',
    isDetail: false,
  },
  {
    state: 'app.experiments',
    url: '/settings/experiments',
    isDetail: false,
  },
  {
    state: 'app.integration',
    url: '/settings/integration',
    isDetail: false,
  },
  {
    state: 'app.performance-standards',
    url: '/settings/performancestandards',
    isDetail: false,
  },
  {
    state: 'app.printing',
    url: '/settings/printing',
    isDetail: false,
  },
  {
    state: 'app.status',
    url: '/settings/status',
    isDetail: false,
  },
  {
    state: 'app.update',
    url: '/settings/update',
    isDetail: false,
  },
  {
    state: 'app.users',
    url: '/settings/users',
    isDetail: false,
  },
  {
    state: 'app.user',
    url: '/settings/users',
    isDetail: true,
  },
  {
    state: 'app.tooling_list',
    url: '/tooling',
    isDetail: false,
  },
  {
    state: 'app.tooling_detail',
    url: '/tooling',
    isDetail: true,
  },
  {
    state: 'app.warehouse_settings',
    url: '/warehouse/app-settings',
    isDetail: false,
  },
  {
    state: 'app.warehouse_tasks',
    url: '/warehouse/tasks',
    isDetail: false,
  },
  {
    state: 'app.warehouse_users',
    url: '/warehouse/users',
    isDetail: false,
  },
];
